import { registerPaymentMethod } from '@woocommerce/blocks-registry';

if( wwpscript.payment_methods && wwpscript.payment_methods.length > 0 ) {
    wwpscript.payment_methods.forEach(function(i, e) {
        var payment_method_data = window.wc.wcSettings.getPaymentMethodData(i);
        registerPaymentMethod( {
            name: i,
            label: <div>{payment_method_data.title}</div>,
            content: <div>{payment_method_data.description}</div>,
            edit: null,
            icons: null,
            canMakePayment: () => true,
            ariaLabel: "Wholesale",
            supports: {
                features: undefined,
            }
        });
    });
}